// Default timeout for server-side data fetches.
//
// Bounds otherwise-unbounded fetch() calls so a slow or unresponsive upstream
// (e.g. api.roomster.com) cannot pin the single Node event loop indefinitely.
// Without this, hung SSR fetches accumulate, the health-check endpoint starves,
// and every replica can be marked unhealthy at once — taking the whole service
// to 0 replicas. The value is deliberately generous so it only trips on genuine
// hangs, not on slow-but-alive responses.
export const DEFAULT_REQUEST_TIMEOUT_MS = 15_000;
